import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { resetUserDetails } from "redux/actions/userActions";
import { properCase } from "../../../../utils";
import { MEAL, DELETED } from "pages/Punch/constants";
// MUI
import {
  TextField,
  Button,
  makeStyles,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core";
// import CardLayout from "../CardLayout";
import CardLayout from "pages/Dashboard2.1/components/CardLayout";
import {
  getActivityGroups,
  getExceptions,
  getJobFamilies,
  getLocations,
} from "../../../../redux/actions/appActions";
import CircularButton from "components/CircularButton";
import MealsAlertDialog from "components/MealsAlertDialog";
import { empIDMaxLength } from "config";
import { getPunch, getUniqueID } from "../../../../utils/punch";
import moment from "moment";
import { addPunch, updatePunch } from "../../../../services";
import { PUNCH } from "../../../../navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
import { dateConfig, TRANSFER, LAST, SET_EMPTY } from "../../../Punch/config";
import { getUser } from "../../../../redux/actions/userActions";
import { categoryPunch } from "../../../Punch/constants";
import { DEVICE_DETAILS } from "../../../../config/index";
import { USER_ERRORS } from "redux/CONSTANTS";
import PinAccess from "./components/PinAccess";
import { useRemoteConfig } from "providers";
import { convertStringToArray } from "utils/rcUtils";

const inputProps = {
  maxLength: empIDMaxLength,
};

const useStyles = makeStyles((theme) => ({
  root: {
    // textAlign: "center",
    display: "flex",
    flexDirection: "row-reverse",
    // alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
      // width: "25ch",
    },
  },
  boxContent: {
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: "rgba(80, 80, 80, 1.0)",
  
  },
  dialogContent: {
    paddingLeft: 35,
  },
  actionRoot: {
    display: "block",
   
  },
  outerContainer: {
    // display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 47,
  },
  innerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
 

 
}));

const WorkerView = ({
  getEmployee,
  closeModalIdNotificationMsg,
  handleAddWorker,
  setMealEndLoader
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { error, idNotificationMsg, user } = useSelector((state) => state.user);

  const pinAccess = useRemoteConfig("pinAccess");
  const pinAccessCountries = convertStringToArray(pinAccess);

  //const { user, lastPunch } = useSelector((state) => state.user);
  const [mealModalVisible, setMealModalVisible] = useState(false);
  const [pinModalVisible, setPinModalVisible] = useState(false);
  const [customerSite, setCustomerSite] = useState(SET_EMPTY);
  const history = useHistory();
  const [showMealEndConfirmation, setShowMealEndConfirmation] = useState(false);
  const [showNegativeMealEndConfirmation, setShowNegativeMealEndConfirmation] = useState(false);
  const [lastPunch, setLastPunch] = useState();
  const [loading, setLoading] = useState(false);
  const [lastPunchInLocalTs, setLastPunchInLocalTs]= useState();

  useEffect(() => {
    dispatch(getActivityGroups());
    dispatch(getJobFamilies());
    dispatch(getExceptions());
    //dispatch(getLocations());
  }, []);
  useEffect(() => {
    console.log("PINACCESSCOUNTRIES:" + JSON.stringify(pinAccessCountries));
  }, [pinAccess]);

  const dispatch = useDispatch();
  const [empId, setEmpId] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(true);
  // Clear input on load
  // useEffect(() => {
  //   setEmpId("");
  //   dispatch(resetUserDetails());
  // }, []);

  const gotoPunch = function () {
    history.push(PUNCH);
  };

  const showMealModal = () => setMealModalVisible(true);
  const hideMealModal = () => setMealModalVisible(false);

  const changeHandler = (ev) => {
    ev.preventDefault();
    if (ev.target.value === "") {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
    setEmpId(ev.target.value);
  };

  const checkLastWasMeal = () => {
    if (
      lastPunch &&
      lastPunch.activityGroup === MEAL &&
      lastPunch.status != DELETED &&
      !lastPunch.outTS &&
      !lastPunch.outLocalTS
    ) {
      setMealModalVisible(true);
    } else {
      gotoPunch();
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    getEmployee(empId, (err, { user, punch }) => {
      setLastPunch(punch);
      if (!err) {
        if (pinAccessCountries.includes(user.country)) {
          setPinModalVisible(true);
        } else {
          if (
            punch &&
            punch.activityGroup === MEAL &&
            punch.status != DELETED &&
            !punch.outTS &&
            !punch.outLocalTS
          ) {
            setMealModalVisible(true);
          } else {
            gotoPunch();
          }
        }
      }
      console.log(err, user, punch);
      setLoading(false);
    });
  };
  const addWorkerHandler = (e) => {
    e.preventDefault();
    handleAddWorker(empId);
  };

  const cancelHandler = (e) => {
    e.preventDefault();
    setEmpId("");
    closeModalIdNotificationMsg();
  };

  const mealEndHandler = (isActivityContinued) => {
    console.log('isActivityContinued:', isActivityContinued);
    if (isActivityContinued) {
      setMealEndLoader(true);
      setMealModalVisible(false);
      const timeStamp = new Date();
      const outTS = timeStamp.toISOString();
      const actionTS = timeStamp.toISOString();
      const outLocalTS = moment(timeStamp).format(dateConfig.format4);
      const activityName = TRANSFER;
      const version = getUniqueID();
      lastPunch.outTS = outTS;
      lastPunch.actionTS = actionTS;
      lastPunch.outLocalTS = outLocalTS;

      let lastActivity = LAST + user.lastActGrp;
      const newPunch = getPunch(
        user.lastActGrp ? user.lastActGrp : "",
        activityName,
        lastPunch.buildingId,
        lastPunch.districtId,
        lastPunch.customerSite ? lastPunch.customerSite : customerSite,
        lastPunch.exceptionName,
        lastPunch.isException,
        lastPunch.jobName,
        user && user[lastActivity] ? user[lastActivity] : "",
        lastPunch.status,
        version,
        user.workerId,
        actionTS,
        outTS,
        outLocalTS,
        SET_EMPTY,
        SET_EMPTY,
        user.workerId,
        DEVICE_DETAILS,
        categoryPunch
      );
      const recentPunchIn = moment(lastPunch.inLocalTS).format(
        dateConfig.format7
      );
      const recentPunchOut = moment(outLocalTS).format(dateConfig.format7);
      if(lastPunch.projectDetails || lastPunch.projectDetails===SET_EMPTY){
        if(lastPunch.projectDetails === SET_EMPTY){
          newPunch.projectDetails = SET_EMPTY;
        }else newPunch.projectDetails =lastPunch.projectDetails;
        
      }
      if (recentPunchOut < recentPunchIn)
      {
        setLastPunchInLocalTs(recentPunchIn);
        setShowNegativeMealEndConfirmation(true);
        setMealEndLoader(false);

      }
      else {
          updatePunch(lastPunch.punchId, lastPunch)
            .then(() => {
              addPunch(newPunch, false, false).then(() => {
                setMealModalVisible(false);
                setEmpId(SET_EMPTY);
                setShowMealEndConfirmation(true);
                setMealEndLoader(false);
              }).catch((error) => {
                setMealEndLoader(false);
                console.log(error);
              });;
              console.log("Meal Punch", newPunch);
            })
            .catch((error) => {
              setMealEndLoader(false);
              console.log(error);
            });

      }
    } else {
      setMealModalVisible(false);
      dispatch(getUser(empId, callback));
    }
  };

  var callback = function () {
    history.push(PUNCH);
  };

  return (
    <>
    
      <CardLayout title={properCase(t("pgHome.tlActivity"))} styel={{alignItems:"right"}}>
        <form noValidate autoComplete="off" onSubmit={submitHandler}>
          <Box className={classes.outerContainer}>
            <Box className={classes.innerContainer}>
              <Box>
               
                <TextField
                  label={t("pgHome.phEmpId")}
                  autoFocus
                  required
                  variant="outlined"
                  value={empId}
                  placeholder={t("pgHome.phEmpId")}
                  onChange={changeHandler}
                  error={error ? true : false}
                  className={classes.makeStylesBoxContent31}
                  helperText={
                    error
                      ? t(error)
                      : loading
                      ? properCase(t("pgHome.loadingWorker"))
                      : ""
                  }
                  inputProps={inputProps}
                  size="small"
                />
              </Box>
              {/* </Grid> */}
              <Box pl={1}>
                {/* <Grid item> */}
                <CircularButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={disableSubmit}
                  isLoading={loading}
                >
                  {/* {t("pgHome.btEmpId")} */}
                </CircularButton>
                {/* </Grid>
          </Grid> */}
              </Box>
            </Box>
            <MealsAlertDialog
              mealModalVisible={mealModalVisible}
              hideMealModal={hideMealModal}
              actionRootClass={classes.actionRoot}
            >
              <Box className={classes.root}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    mealEndHandler(true);
                    // setShowMealEndConfirmation(true);
                  }}
                >
                  {t("other.btnContinueActivity")}
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => mealEndHandler(false)}
                >
                  {t("pgPunch.btnTransfer")}
                </Button>
              </Box>
            </MealsAlertDialog>
          </Box>
        </form>
      </CardLayout>
      <Dialog
        open={idNotificationMsg}
        onClose={closeModalIdNotificationMsg}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <Box className={classes.boxContent}>
          <DialogTitle color="primary" id="form-dialog-title">
            ID Notification
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText>
              {t("pgHome.pIdNotification1")}
            </DialogContentText>
            <DialogContentText>
              {t("pgHome.pIdNotification2")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={cancelHandler}>
              {t("pgAddWorker.btnCancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={addWorkerHandler}
            >
              {t("pgHome.btnAdd")}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <Dialog
        open={showMealEndConfirmation}
        //onClose={() => mealEndHandler(true)}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        {/* <DialogTitle id="form-dialog-title">Confirmation</DialogTitle> */}
        <DialogTitle id="form-dialog-title">
          {t("pgPunch.tlConfirmation")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("pgReview.dialogueMsgs.msgSuccess")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              // mealEndHandler(true);
              setShowMealEndConfirmation(false);
            }}
            color="primary"
          >
            {"OK"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showNegativeMealEndConfirmation}
        //onClose={closeNegativeMealEndModalConfirmationMsg}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
        {t("other.errMsgNegativePunchTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText> {t("other.errMsgNegativePunch")}</DialogContentText>
          <DialogContentText> {t("other.errMsgNegativePunchTwo")} {lastPunchInLocalTs}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button  onClick={() => {
              // mealEndHandler(true);
              setShowNegativeMealEndConfirmation(false);
            }} color="primary">
            {t("pgPunch.btnOK")}
          </Button>
        </DialogActions>
      </Dialog>
      <PinAccess
        {...{ worker: user, lastPunch, showPinAccess: pinModalVisible }}
        onPinAccessSuccess={(isNewPinSet) => {
          setPinModalVisible(false);
          if (!isNewPinSet) {
            checkLastWasMeal();
          }
        }}
        onCancel={() => {
          setPinModalVisible(false);
        }}
      />
    </>
  );
};

export default WorkerView;
